
(function documentControllerDefinition() {
    'use strict';

    angular.module('Document')
        .controller('DocumentModifyController', [
            '$scope', '$translate', '$state', '$q', 'errorsExtend', '$stateParams', 'documentService', 'authExtend', '$rootScope', 'auth', 'twainCapture', 
            'documentTypeService', 'documentContainerService', 'fileService', 'config', 'storageService', 'containerTypeService', '$filter',
            function documentController($scope, $translate, $state, $q, errors, $stateParams, documentService, authExtend, $rootScope, auth, twainCapture,
                documentTypeService, documentContainerService, fileService, config, storageService, containerTypeService, $filter) {

                twainCapture.setFileNameStartIndex();

                $scope.canDigitalize = auth.isInRole('DOCUMENT DIGITALIZATION');
                $scope.canAddToContainer = auth.isInRole('ASSOCIATE CONTAINERS');
                $scope.canAddItemsToComboMetadata = auth.isInRole('METADATA INSERT');
                $scope.showGoBackSearch = (storageService.getStateBackFind() && storageService.getStateBackFind() !== '');
                $scope.docContainersPlaceHolder = 'DocumentDocumentContainerPlaceholder';
                $scope.metadataAsName = 0;
                $scope.hasNameTemplate = false;
                $scope.hasOrderTemplate = true;

                $scope.auditEntity = {
                    creationDate: new Date(),
                    userId: auth.getUserId(),
                    userName: auth.getUserNick(),
                    applicationId: config.appId(),
                    applicationName: config.appName(),
                    organizationalUnitId: auth.getOrganizationId(),
                    organizationalUnitName: auth.getOrganizationName(),
                    actionType: { id: 37 }//FileDownLoad
                };


                $scope.changeAsName = function (value) {
                    if (value.updatesName) {
                        $scope.document.name = value.metadataValue;
                    }
                };

                $scope.initDocumentFind = function () {
                    if (storageService.getStateBackFind()) {
                        $state.go(storageService.getStateBackFind());
                    }
                };

                $scope.aux = {
                    selectedDocumentTypes: [],
                    files: [],
                    filesTemp: [],
                    metadataReplicate: []
                };

                $scope.document = {
                    id: $stateParams.id,
                    name: '',
                    documentTypes: [],
                    containers: [],
                    organizationalUnitId: authExtend.getOrganizationId(),
                    files: []
                };

                $scope.preview = {
                    closed: true,
                    loading: false,
                    content: null,
                    index: null,
                    item: null,
                    invalid: false
                };

                $scope.auxDocumentType = {};
                $scope.optionsDocumentTypes = [];

                $scope.loadMetadata = function (documentType, oldValues) {

                    var documentDocType = {
                        documentTypeName: documentType.name,
                        documentTypeId: documentType.id,
                        metadatas: []
                    };

                    if (oldValues) {
                        documentDocType.id = oldValues.id;
                    }

                    documentType.metadata.forEach(function (metadata) {
                        var value = '';

                        if (oldValues) {
                            for (var i in oldValues.metadatas) {
                                if (oldValues.metadatas.hasOwnProperty(i)) {
                                    if (oldValues.metadatas[i].metadataId === metadata.metadataId) {
                                        value = oldValues.metadatas[i].metadataValue;
                                        break;
                                    }
                                }
                            };
                        }

                        var meta = {
                            idObject: documentDocType.documentTypeId + '' + metadata.metadataId,
                            metadataId: metadata.metadataId,
                            metadataIsRequired: metadata.isRequired,
                            metadataIsUnique: metadata.isUnique,
                            metadataValue: value,
                            metadataType: metadata.metadataType,
                            metadataLabel: metadata.metadataLabel,
                            metadataOptions: metadata.optionValues,
                            maskOptions: metadata.maskOptions,
                            mask: metadata.metadataMask,
                            maskPlaceHolder: metadata.metadataMaskPlaceHolder,
                            metadataAsName: metadata.asName,
                            metadataSystemName: metadata.metadataSystemName,
                            metadataAttributes: metadata.attributes,
                            metadataIsMultivalue: metadata.isMultivalue,
                            metadataIsUpdateable: (metadata.isUpdateable && $scope.canAddItemsToComboMetadata)
                        };

                        documentDocType.metadatas.push(meta);

                        if (metadata.asName) {
                            if (!$scope.metadataAsName) {
                                // por si cambió el valor mientras se podía.
                                $scope.document.name = value;
                                meta.updatesName = true;
                            }
                            $scope.metadataAsName++;
                        }
                    });

                    $scope.document.documentTypes = [];
                    $scope.document.documentTypes.push(documentDocType);

                    if (oldValues) {
                        $scope.replicateValues(false);
                    } else {
                        $scope.replicateValues(true);
                    }
                };

                $scope.selectDocumentType = function (documentType, typeValues) {
                    documentTypeService.getById(documentType.id, 'Detail').then(function (result) {
                        $scope.hasNameTemplate = result.nameTemplate !== null;
                        $scope.loadMetadata(result, typeValues);
                    }, function (error) {
                        errors.showError(error);
                        $scope.cancel();
                    });
                };

                $scope.cancel = function () {
                    $state.goBack('mydocument-detail', { id: $scope.document.id });
                };

                $scope.loadTypes = function () {
                    var defered = $q.defer();
                    var promise = defered.promise;


                    documentTypeService.getFunctionsTypes(['DOCUMENT WRITE', 'DOCUMENTVERSIONED WRITE'])
                        .then(function (types) {
                            $scope.optionsDocumentTypes = types.sort(function (a, b) {
                                return a.name.localeCompare(b.name);
                            });
                            defered.resolve();
                        }, function (error) {
                            errors.showError(error);
                            defered.reject();
                        });
                    return promise;
                };

                $scope.loadDocument = function () {
                    var defered = $q.defer();
                    var promise = defered.promise;

                    documentService.getById($stateParams.id, true).then(function (result) {
                        $scope.loadResult = result;
                        $scope.hasNameTemplate = $scope.loadResult.documentTypes[0].nameTemplate !== null;
                        $scope.hasOrderTemplate = $scope.loadResult.documentTypes[0].orderTemplate !== null;
                        defered.resolve();

                    }, function (error) {
                        errors.showError(error);
                        defered.reject();

                    });
                    return promise;
                };

                function checkType(value) {

                    for (var i in $scope.loadResult.documentTypes) {
                        if ($scope.loadResult.documentTypes.hasOwnProperty(i)) {
                            if ($scope.loadResult.documentTypes[i].documentTypeId === value.id) {
                                value.status = 'preSeleted';
                                return true;
                            }
                        }
                    }
                    return false;
                }

                $scope.load = function () {

                    var promesaMultipleArray = $q.all([$scope.loadDocument(),
                    $scope.loadTypes()]);

                    promesaMultipleArray.then(function () {
                        $scope.aux.files = $scope.loadResult.files;
                        $scope.document.versionId = $scope.loadResult.versionId;
                        $scope.document.code = $scope.loadResult.code;
                        $scope.document.name = $scope.loadResult.name;
                        $scope.document.order = $scope.loadResult.order;
                        for (var i = 0; i < $scope.aux.files.length; i++) {
                            $scope.aux.files[i].fsize = fileService.FormatfileSize($scope.aux.files[i].size);
                        }
                        $scope.loadResult.containers.forEach(function (container) {

                            container.notEditable = false;

                            $scope.document.containers.push(container);

                            $scope.selectContainer(container, true);
                        });

                        var selectedDocumentType = $scope.optionsDocumentTypes.filter(checkType);

                        $scope.aux.selectedDocumentTypeid = selectedDocumentType[0].id;

                        $scope.loadResult.documentTypes.forEach(function (type) {
                            $scope.selectDocumentType({ id: type.documentTypeId }, type);
                        });

                        if ($scope.aux.files.length > 0) {

                            if ($scope.aux.files[0].size < config.maxFileSizeToPreview()) {
                                $scope.previewFile($scope.aux.files[0], 0);
                            }
                        }

                    }, function () {
                        $scope.cancel();
                    });


                };

                $scope.load();

                $scope.addFile = function () {
                    $scope.aux.filesTemp.forEach(function (file) {
                        file.fsize = fileService.FormatfileSize(file.size);
                        if (file && file.size) {
                            if (!$scope.canAdd(file)) {
                                errors.showError('SameNameAsSystemCreated');
                            } else {
                                var index = $scope.getIndexFile(file);
                                if (~index) {
                                    $scope.aux.files[index] = file;
                                } else {
                                    $scope.aux.files.push(file);
                                }
                            }
                        }
                    });
                    $scope.aux.filesTemp = [];
                };

                $scope.canAdd = function (file) {

                    var flag = true;

                    $scope.aux.files.forEach(function (f) {

                        if (file.name.toLowerCase() === f.name.toLowerCase() && f.isSystemCreated) {
                            flag = false;
                            return;
                        }

                    });

                    return flag;
                };

                $scope.getIndexFile = function (fileNew) {

                    for (var i in $scope.aux.files) {
                        if ($scope.aux.files.hasOwnProperty(i)) {
                            var fileOld = $scope.aux.files[i];

                            if (fileOld.name === fileNew.name) {
                                return i;
                            }
                        }
                    };

                    return -1;
                };

                $scope.removeFile = function (file) {
                    var index = $scope.getIndexFile(file);

                    if (~index) {
                        if ($scope.preview.index === index) {
                            $scope.hidePreview();
                        }
                        $scope.aux.files.splice(index, 1);
                    }
                };

                $scope.save = function (checkin) {

                    if (!$scope.documentForm.$valid) {
                        $scope.documentForm.$setSubmitted();
                        errors.showError('VerifyFormData');
                        return false;
                    }
                    
                    // Validate Metadata items
                    var hasErrors = false;
                    var comboMetadatas = $filter('filter')($scope.document.documentTypes[0].metadatas, { metadataType: 'comboKV' }, true);
                    if (comboMetadatas.length > 0) {
                        comboMetadatas.forEach(function (metadata) {
                            if (Array.isArray(metadata.metadataValue)) {
                                metadata.metadataValue.forEach(function (metadataValue) {
                                    var item = $filter('filter')(metadata.metadataOptions, { value: metadataValue, active: false }, true);
                                    if (item.length > 0) {
                                        $scope.documentForm.$setSubmitted();
                                        errors.showError($translate.instant('InactiveItemMetadata', { entidad: 'Documento', metadataLabel: metadata.metadataLabel }));
                                        hasErrors = true;
                                        return false;
                                    }
                                });
                            } else {
                                var item = $filter('filter')(metadata.metadataOptions, { value: metadata.metadataValue, active: false }, true);
                                if (item.length > 0) {
                                    $scope.documentForm.$setSubmitted();
                                    errors.showError($translate.instant('InactiveItemMetadata', { entidad: 'Documento', metadataLabel: metadata.metadataLabel }));
                                    hasErrors = true;
                                    return false;
                                }
                            }
                        });
                    }

                    if (hasErrors) {
                        return false;
                    }

                    var files = [];
                    $scope.document.files = [];

                    $scope.aux.files.forEach(function (file) {
                        file.fsize = fileService.FormatfileSize(file.size);
                        if (file.id && file.id > 0) {
                            $scope.document.files.push(file);
                        } else {
                            files.push(file);
                        }
                    });

                    return documentService.modify($scope.document, files, checkin)
                        .then(function (result) {      
                            $state.go('document-find');
                        }, function (error) {
                            errors.showError(error);
                        });
                };

                $scope.previewFile = function (item, index) {

                    $scope.preview.content = null;
                    $scope.preview.loading = true;
                    $scope.preview.closed = false;
                    $scope.preview.invalid = false;

                    fileService.preview($scope.aux.files[index], true).then(function (result) {

                        $scope.preview.content = result;

                        $scope.preview.item = item;
                        $scope.preview.index = index;
                        $scope.preview.loading = false;

                        $scope.auditEntity.entityid = $scope.loadResult.id;
                        $scope.auditEntity.EntityName = 'DOCUMENT';
                        $scope.auditEntity.entity = JSON.stringify({
                            documentId: $scope.loadResult.id,
                            documentTypeName: $scope.loadResult.documentTypes[0].documentTypeName,
                            documentName: $scope.loadResult.name,
                            fileCreatedBy: $scope.loadResult.createdByNickName,
                            fileCreationDate: $scope.preview.item.creationDate,
                            fileDownloadedBy: auth.getUserId(),
                            fileDownloadedDate: new Date(),
                            organizationalUnit: auth.getOrganizationId(),
                            metadatas: $scope.loadResult.documentTypes[0].metadatas.map(function (obj) {
                                var rObj = {};
                                rObj[obj.systemName] = obj.metadataValue;
                                return rObj;
                            })
                        });


                    }, function (error) {
                        if (error.data && error.data.modelState && error.data.modelState.no_converter) {
                            $scope.preview.loading = false;
                            $scope.preview.invalid = true;
                            $scope.preview.item = item;
                            $scope.preview.index = index;
                        }
                        else {
                            $scope.preview.loading = false;
                            $scope.preview.invalid = true;
                        }
                    });

                };

                $scope.hidePreview = function () {

                    $scope.preview = {
                        closed: true,
                        loading: false,
                        content: null,
                        index: null,
                        invalid: false,
                        item: null
                    };
                };

                $scope.nextPreview = function () {
                    if ($scope.preview.index + 1 < $scope.aux.files.length) {
                        $scope.preview.index++;
                        $scope.previewFile($scope.aux.files[$scope.preview.index], $scope.preview.index);
                    }
                };

                $scope.prevPreview = function () {
                    if ($scope.preview.index) {
                        $scope.preview.index--;
                        $scope.previewFile($scope.aux.files[$scope.preview.index], $scope.preview.index);
                    }
                };

                $scope.metadataCount = function () {
                    if ($scope.document.documentTypes && $scope.document.documentTypes.length) {
                        return $scope.document.documentTypes.reduce(function (valorPrevio, valorActual, indice, array) { return valorPrevio + valorActual.metadatas.length; }, 0);
                    }
                    return 0;
                };

                $scope.getReplicatedMetadata = function (metadata) {
                    for (var i = 0; $scope.aux.metadataReplicate.length > i; i++) {
                        if (metadata.metadataId === $scope.aux.metadataReplicate[i].metadataId && $scope.aux.metadataReplicate[i].containerId) {
                            return $scope.aux.metadataReplicate[i];
                        }
                    }

                    return null;
                };

                $scope.replicateValues = function (changeValue) {
                    for (var k = 0; $scope.document.documentTypes.length > k; k++) {
                        for (var l = 0; $scope.document.documentTypes[k].metadatas.length > l; l++) {
                            var m = $scope.document.documentTypes[k].metadatas[l];
                            var replicated = $scope.getReplicatedMetadata(m);
                            if (replicated) {
                                if (changeValue) {
                                    m.metadataValue = replicated.metadataValue;
                                }

                                m.metadataReadOnly = true;
                            } else {
                                m.metadataReadOnly = false;
                            }
                        }
                    }
                };

                $scope.selectContainer = function (item, load) {
                    var finData = false;
                    containerTypeService.getById(item.containerTypeId).then(function (type) {
                        type.metadata.forEach(function (m) {

                            if (m.isReplicated) {
                                $scope.aux.metadataReplicate.push({
                                    value: undefined,
                                    metadataId: m.metadataId,
                                    containerId: undefined
                                });
                                finData = true;
                            }
                        });

                        if (finData) {
                            documentContainerService.getById(item.id).then(function (container) {
                                $scope.aux.metadataReplicate.forEach(function loadValues(metadata) {
                                    for (var i = 0; container.metadatas.length > i; i++) {
                                        if (metadata.metadataId === container.metadatas[i].metadataId) {
                                            metadata.metadataValue = container.metadatas[i].metadataValue;
                                            metadata.containerId = item.id;
                                            break;
                                        }
                                    }
                                });

                                $scope.replicateValues(true);
                            }, function (error) {
                                errors.showError(error);
                            });
                        }
                    }, function (error) {
                        if (error && error.status === 403) {
                            // si no tiene permisos lo dejo seguir. Los datos se van a replicar a nivel de api
                            return;
                        }

                        errors.showError(error);
                    });
                };

                $scope.removeContainer = function (item) {
                    var aux = [];

                    $scope.aux.metadataReplicate.forEach(function (metadata) {
                        if (metadata.containerId !== item.id) {
                            aux.push(metadata);
                        }
                    });

                    $scope.aux.metadataReplicate = aux;
                    $scope.replicateValues(false);
                };

                $scope.beginDigitalization = function () {
                    $scope.digitalizerOpen = true;
                };

                $scope.cancelDigitalization = function () {
                    $scope.digitalizerOpen = false;
                };

                $scope.scanning = false;
                $scope.hasScannedDocument = false;

                $scope.digitalize = function () {

                    $scope.scanning = true;

                    var callback = function () {
                        twainCapture.scanOne()
                            .then(function (index) {
                                $scope.scanning = false;
                                $scope.hasScannedDocument = (twainCapture.imagesCount() !== 0);
                            }, function (error) {
                                $scope.scanning = false;
                                $scope.hasScannedDocument = (twainCapture.imagesCount() !== 0);
                                errors.showError(error);
                            });
                    };

                    twainCapture.deleteFirstImage().then(callback, callback);
                };

                $scope.addDigitalized = function () {

                    /* Busco si ya existe un archivo con el indice */
                    var fileName = twainCapture.findUniqueName($scope.aux.files.concat($scope.aux.filesTemp));

                    twainCapture.popImageFile(fileName)
                        .then(function (file) {
                            $scope.hasScannedDocument = (twainCapture.imagesCount() !== 0);
                            $scope.aux.filesTemp.push(file);
                            $scope.addFile();
                        }, function (error) {
                            $scope.hasScannedDocument = (twainCapture.imagesCount() !== 0);
                            errors.showError(error);
                        });
                };

                $scope.configureDigitalization = function () {
                    twainCapture.showConfigUi();
                };

                $scope.$watch(function () {
                    return twainCapture.isAvailable();
                }, function (val) {
                    $scope.digitalizerNotAvaliable = !val;
                });

            }]);

})();